import React, { useState } from 'react';
import { X } from 'lucide-react';

const EventGalleryModal = ({ event, onClose }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  if (!event) return null;

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closePreview = () => {
    setSelectedImage(null);
  };

  return (
    <div className="fixed inset-0 bg-black/70 z-50 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-4xl shadow-xl transform transition-all">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                {event.title} Gallery
              </h2>
              <button
                onClick={onClose}
                className="rounded-full p-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                <X className="w-6 h-6 text-gray-500 hover:text-gray-700 dark:text-gray-400" />
              </button>
            </div>

            {/* Gallery Grid */}
            <div className="p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {event.gallery.map((image, index) => (
                  <div
                    key={index}
                    className="group relative rounded-lg overflow-hidden cursor-pointer"
                    onClick={() => handleImageClick(image)}
                  >
                    <div className="aspect-w-16 aspect-h-12">
                      <img
                        src={image}
                        alt={`${event.title} gallery ${index + 1}`}
                        className="w-full h-full object-cover transform transition-transform group-hover:scale-105"
                      />
                    </div>
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Full Image Preview */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-60 flex items-center justify-center bg-black/90 animate-in fade-in duration-200"
          onClick={closePreview}
        >
          <div className="relative max-w-screen-xl max-h-screen-90 p-4">
            <button
              onClick={closePreview}
              className="absolute top-4 right-4 p-2 rounded-full bg-black/50 hover:bg-black/70 transition-colors"
            >
              <X className="w-6 h-6 text-white" />
            </button>
            <img
              src={selectedImage}
              alt="Full preview"
              className="max-h-[90vh] max-w-[90vw] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EventGalleryModal;